import { useApolloClient } from "@apollo/client";
import { Modal } from "@msys/ui";
import { Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useSnackbar } from "notistack";
import * as React from "react";

interface Props {
  handleClose: () => void;
}

/**
 * Modal shown after the user clicks "Search products with FIS SOLR".
 */
export function FisSolrSearchModal({ handleClose }: Props) {
  const { t } = useTranslate(["SapS4Hana", "Global"]);
  const client = useApolloClient();
  const { enqueueSnackbar } = useSnackbar();
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    try {
      setIsRefreshing(true);
      await client.refetchQueries({ include: "active" });
      handleClose();
    } catch (err) {
      if (err instanceof Error) {
        enqueueSnackbar(err.message, { variant: "error" });
      }
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <Modal
      title={t("Search products with FIS SOLR", { ns: "SapS4Hana" })}
      actionButtons={[
        {
          label: t("Cancel", { ns: "Global" }),
          handleClick: handleClose,
          buttonProps: {
            variant: "text",
            disabled: isRefreshing,
          },
        },
        {
          label: t("Refresh", { ns: "Global" }),
          handleClick: handleRefresh,
          buttonProps: {
            variant: "contained",
            loading: isRefreshing,
          },
        },
      ]}
      handleClose={handleClose}
    >
      <Typography variant="body1">
        {t("The FIS SOLR product search has been opened in a new tab.", {
          ns: "SapS4Hana",
        })}
      </Typography>
    </Modal>
  );
}
